module.exports = __webpack_public_path__ + "img/egg-bg-main1.1c9cac58.svg";